import * as React from "react";
import { Box, Typography, Button, Stack } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

export function NotFoundPage(): React.JSX.Element {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
        textAlign: "center",
        gap: 2,
      }}
    >
      <Stack spacing={2} alignItems="center">
        <Typography variant="h3">404</Typography>
        <Typography variant="body1" color="text.secondary">
          The page you are looking for does not exist.
        </Typography>
        <Button component={RouterLink} to="/dashboard" variant="contained">
          Return to Dashboard
        </Button>
      </Stack>
    </Box>
  );
}
